// extracted by mini-css-extract-plugin
export default {"container":"TMiTl5b4SKc_S_2Qd_VA","heading":"aKTUwgXASfU_gwqGEDTc"};